import React, { Component } from "react"
import { Link } from 'react-router-dom'
import { dataMain } from "../../data"
import { noContextMenu } from "../../logic/DOMElementsRelated.js"

class NavBar extends Component {
  constructor(props) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
    // this.handleKeyDown = this.handleKeyDown.bind(this)
  }

  componentDidMount() {
    noContextMenu()
    // this.keyCodeListener()
  }
  
  // componentWillUnmount() {
  //   document.removeEventListener('keydown', this.handleKeyDown)
  // }


  // keyCodeListener() {
  //   document.addEventListener('keydown', this.handleKeyDown) 
  // }

  // handleKeyDown(event) {
  //   switch(event.code) {
  //     case "KeyO":
  //       // console.log("from nav")
  //       this.openSeaPressed(document.getElementById('openSeaLink'))
  //       break

  //     case "Backspace":        
  //       // console.log("from nav")
  //       this.homePressed(document.getElementById('homeLink'))
  //       break
        
  //     default: break
  //   }
  // }

  handleClick(event) {
    switch(event.target.dataset.id) {
      case "homeBtn": 
        this.buttonPressed(event.target.parentElement.children)
        setTimeout(() => {
          this.buttonPressed(event.target.parentElement.children)
        }, 400)
        break

      case "openSeaBtn": 
        this.linksPressed(event.target.parentElement, '_blank')
        break

      default: break
    }
  }

  buttonPressed(children) {
    for (let i = 0; i < children.length; i++) {
      children[i].classList.toggle('hidden')
      children[i].classList.toggle('visible')
    }
  }

  // homePressed(parent) {
  //   this.buttonPressed(parent.children)
  //   setTimeout(() => {
  //     this.buttonPressed(parent.children)
  //     window.open(parent.dataset.href, "_self")
  //   }, 400)
  // }

  linksPressed(parent, direction) {
    this.buttonPressed(parent.children)
    setTimeout(() => {
      this.buttonPressed(parent.children)
      window.open(parent.dataset.href, direction)
    }, 400)
  }
  
  render() {
    return (
      <nav className="navBar" id="navBar">
        <Link to='/' className="navBarLink pointerHover"  data-href="/" id="homeLink">
          <img draggable="false" src={dataMain.imgSrc[1]} alt="home Up" className="navbarHome visible noContextMenu" onClick={this.handleClick} data-id="homeBtn" title="Go to home, use Backspace as a shortcut." />
          <img draggable="false" src={dataMain.imgSrc[2]} alt="home Down" className="navbarHome hidden noContextMenu" onClick={this.handleClick} data-id="homeBtn" title="Go to home, use Backspace key as a shortcut." />
        </Link>
        <div className="siteTitleContainer">
          <div className="siteTitle">
            MUSIC PRODUCTION TOKEN
          </div>
          <div className="siteSubTitle">
            STAND ALONE BLOCKCHAIN INSTRUMENT
          </div>
        </div>
        <div data-href="https://opensea.io/collection/musicproductiontoken" className="openSeaLink pointerHover" id="openSeaLink">
          <img draggable="false" src={dataMain.imgSrc[3]} className="navBarOpenSea visible noContextMenu" alt="openSea Up" onClick={this.handleClick} data-id="openSeaBtn" title="Link to opensea.io MPT collections, use O key as a shortcut." />
          <img draggable="false" src={dataMain.imgSrc[4]} className="navBarOpenSea hidden noContextMenu" alt="openSea Down" onClick={this.handleClick} data-id="openSeaBtn" title="Link to opensea.io MPT collections, use O key as a shortcut." />
        </div>
      </nav>
    )
  }
}

export default NavBar